import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getProviderApplications, deleteJobApplication } from '../../services/firestore';

const JobApplications = () => {
  const { currentUser } = useAuth();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const navigate = useNavigate();

  const fetchApplications = async () => {
    if (!currentUser) return;
    try {
      setLoading(true);
      const applicationsList = await getProviderApplications(currentUser.uid);
      setApplications(applicationsList);
    } catch (err) {
      console.error('Error fetching applications:', err);
      setError('Failed to load applications');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, [currentUser]);

  const handleDelete = async (applicationId) => {
    if (!window.confirm('Are you sure you want to delete this application?')) return;
    setDeleting(applicationId);
    try {
      await deleteJobApplication(applicationId);
      setApplications(prev => prev.filter(app => app.id !== applicationId));
    } catch (err) {
      alert('Failed to delete application: ' + err.message);
    } finally {
      setDeleting(null);
    }
  };

  const formatDate = (dateObj) => {
    if (!dateObj) return '';
    // Firestore Timestamp object
    if (dateObj.seconds) {
      return new Date(dateObj.seconds * 1000).toLocaleDateString();
    }
    // ISO string or Date object
    const date = new Date(dateObj);
    if (isNaN(date.getTime())) return 'Invalid Date';
    return date.toLocaleDateString();
  };

  return (
    <div className="job-applications">
      <h1>Job Applications</h1>
      {error && <div className="error-message">{error}</div>}
      <div className="applications-list">
        {loading ? (
          <div className="loading-container">
            <p>Loading applications...</p>
          </div>
        ) : applications.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>Applicant</th><th>Job Title</th><th>Applied</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {applications.map(application => (
                <tr key={application.id} className="application-row">
                  <td>{application.jobSeekerName || 'N/A'}</td>
                  <td>{application.jobTitle || 'N/A'}</td>
                  <td>{formatDate(application.createdAt)}</td>
                  <td>
                    <div className="table-actions">
                      <button 
                        onClick={() => navigate(`/jobseeker/${application.jobSeekerUid}`)}
                        className="btn btn-outline btn-sm"
                      >
                        View Profile
                      </button>
                      {currentUser && application.providerUid === currentUser.uid && (
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(application.id)}
                          disabled={deleting === application.id}
                        >
                          {deleting === application.id ? 'Deleting...' : 'Delete'}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="empty-state">
            <p>No applications received yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobApplications; 